export default __webpack_public_path__ + "static/media/background.a75276f0.png";